(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDetailController', FeasibilityCheckDetailController);

    FeasibilityCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FeasibilityCheck', 'User', 'Tenant'];

    function FeasibilityCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, FeasibilityCheck, User, Tenant) {
        var vm = this;

        vm.feasibilityCheck = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:feasibilityCheckUpdate', function(event, result) {
            vm.feasibilityCheck = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
